import { render, staticRenderFns } from "./LessonWordContent.vue?vue&type=template&id=2c6bce4e&"
import script from "./LessonWordContent.vue?vue&type=script&lang=js&"
export * from "./LessonWordContent.vue?vue&type=script&lang=js&"
import style0 from "./LessonWordContent.vue?vue&type=style&index=0&id=2c6bce4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports